import moment from 'moment';
import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import LastComponent from './common/lastComponent';

export default function FlightSection({ componentProps }) {
  const { theme } = useSelector((state) => state.ui);
  const { componentName, componentData, componentFullName, isLastComponent } =
    componentProps;
  const component = componentData[componentFullName];

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start relative">
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M22 34L24 34L29 26L34.5 26C35.33 26 36 25.33 36 24.5C36 23.67 35.33 23 34.5 23L29 23L24 15L22 15L24.5 23L19 23L17.5 21L16 21L17 24.5L16 28L17.5 28L19 26L24.5 26L22 34Z"
          fill="white"
        />
      </svg>

      <div className="xs:ml-[16px] mt-2">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative z-10 inline xs:hidden"
          >
            <circle
              cx="25"
              cy="25"
              r="25"
              fill={theme.primaryColour || DEFAULT_SECONDARY_COLOUR}
            />
            <path
              d="M22 34L24 34L29 26L34.5 26C35.33 26 36 25.33 36 24.5C36 23.67 35.33 23 34.5 23L29 23L24 15L22 15L24.5 23L19 23L17.5 21L16 21L17 24.5L16 28L17.5 28L19 26L24.5 26L22 34Z"
              fill="white"
            />
          </svg>
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="max-w-[560px] text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px]">
          Depart from <strong>{component.departureAirport}</strong>{' '}
          {moment(parseInt(component.departureDate, 10)).format('HH:mm')}
          <br />
          Arriving at <strong>{component.arrivalAirport}</strong>{' '}
          {moment(parseInt(component.arrivalDate, 10)).format('HH:mm')}
          <br />
          {component.airline} {component.flightNumber} {component.cabinClass}
          {component.extras &&
            component.extras.map((extra) => <div key={extra}>{extra}</div>)}
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
